import type IPagination from 'interfaces/IPagination';
import { apiServiceProxy } from 'v2/services/api-proxy';
import type { ApiServiceProxy } from 'v2/services/api-proxy';

export type Newzz = {
  id: number;
  title: string;
  content: string;
  external_url?: string;
  has_content?: boolean;
  highlight: boolean;
  created_at: string;

  show_tag_new?: boolean;
};

class NewzzService {
  constructor(private apiService: ApiServiceProxy) {}

  public list(pagination?: IPagination) {
    return this.apiService.get<Newzz[]>('/news', pagination);
  }

  public loadById(id: number) {
    return this.apiService.get<Newzz>(`/news/${id}`);
  }

  public clickNewzz(id: any) {
    return this.apiService.post(`/news/${id}/click`, {});
  }
}

export const newzzService = new NewzzService(apiServiceProxy);
